import { BoelsBaseSite } from '@boels/models';
import { createAction, props } from '@ngrx/store';

export const LOAD_BASE_SITES = '[Site-context] Load BaseSites';
export const LOAD_BASE_SITES_SUCCESS = '[Site-context] Load BaseSites Success';

export const SET_ACTIVE_BASE_SITE = '[Site-context] Set Active BaseSite';

export const loadBaseSites = createAction(
  LOAD_BASE_SITES,
  props<{ isInSmartEdit: boolean }>(),
);

export const loadBaseSitesSuccess = createAction(
  LOAD_BASE_SITES_SUCCESS,
  props<{ baseSites: BoelsBaseSite[]; isInSmartEdit: boolean }>(),
);

export const setActiveBaseSite = createAction(
  SET_ACTIVE_BASE_SITE,
  props<{ payload: string }>(),
);
